import { CommonModule } from '@angular/common';
import { Component, OnDestroy, inject } from '@angular/core';
import { BehaviorSubject, Subject, distinctUntilChanged, map, takeUntil } from 'rxjs';

import { TenantBrandingService, tenantBrandingDefaults } from '../../tenant/tenant-branding.service';

@Component({
  selector: 'app-tenant-hero-image',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tenant-hero-image.component.html',
  styleUrls: ['./tenant-hero-image.component.css'],
})
export class TenantHeroImageComponent implements OnDestroy {
  private readonly branding = inject(TenantBrandingService);
  private readonly destroy$ = new Subject<void>();
  private readonly renderedSourceSubject = new BehaviorSubject<string>(tenantBrandingDefaults.heroImageUrl);

  private requestedSource = tenantBrandingDefaults.heroImageUrl;
  private fallbackAttempted = false;

  readonly renderedSource$ = this.renderedSourceSubject.asObservable();
  imageHidden = false;

  constructor() {
    this.branding.branding$.pipe(
      map((branding) => branding.heroImageUrl),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
    ).subscribe((source) => {
      this.requestedSource = source;
      this.fallbackAttempted = false;
      this.imageHidden = false;
      this.renderedSourceSubject.next(source);
    });
  }

  onImageError(): void {
    if (this.imageHidden) return;

    if (!this.fallbackAttempted && this.requestedSource !== tenantBrandingDefaults.heroImageUrl) {
      this.fallbackAttempted = true;
      this.renderedSourceSubject.next(tenantBrandingDefaults.heroImageUrl);
      return;
    }

    this.imageHidden = true;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
